import { ApolloClient, InMemoryCache, split, HttpLink, ApolloLink } from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import { createClient } from 'graphql-ws';

const GQL_HTTP_URL = import.meta.env.VITE_GQL_HTTP || 'http://localhost:4000/graphql';
const GQL_WS_URL = import.meta.env.VITE_GQL_WS || 'ws://localhost:4000/graphql';

export const createApolloClient = () => {
  const httpLink = new HttpLink({
    uri: GQL_HTTP_URL,
  });

  const authLink = new ApolloLink((operation, forward) => {
    const token = localStorage.getItem('sakura_token');
    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        Authorization: token ? `Bearer ${token}` : '',
      },
    }));
    return forward(operation);
  });

  const wsLink = new GraphQLWsLink(
    createClient({
      url: GQL_WS_URL,
      connectionParams: () => {
        const token = localStorage.getItem('sakura_token');
        return {
          Authorization: token ? `Bearer ${token}` : '',
        };
      },
    })
  );

  const splitLink = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
    },
    wsLink,
    authLink.concat(httpLink)
  );

  const cache = new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          shifts: {
            merge(_, incoming) {
              return incoming;
            },
          },
        },
      },
      Shift: {
        keyFields: ['id'],
      },
      User: {
        keyFields: ['id'],
      },
      LeaveRequest: {
        keyFields: ['id'],
      },
    },
  });

  const client = new ApolloClient({
    link: splitLink,
    cache,
  });

  return client;
};

export default createApolloClient;
